module.exports = __webpack_public_path__ + "static/media/isFriendIcon.a655b63f.svg";